import { UserOpenGraph } from './og';
import { UserTDK } from '@user/head/tdk';
import { FC } from 'react';
import { UserTwitter } from '@user/head/twitter';
import { AbsPageSharingCard } from '@lemon8/web-app-shared/ssr';
import { UserFacebookALMeta } from './facebook';

export class SharingCardMeta extends AbsPageSharingCard {
  PageLevelTDK: FC = () => {
    return <UserTDK />;
  };
  PageLevelOGCard: FC = () => {
    return <UserOpenGraph />;
  };
  PageLevelTWCard: FC = () => {
    return <UserTwitter />;
  };
  PageLevelALMeta: FC = () => {
    return <UserFacebookALMeta />;
  };
}
